import { render, staticRenderFns } from "./SelectPreview.vue?vue&type=template&id=5a07b2b3&scoped=true&"
import script from "./SelectPreview.vue?vue&type=script&lang=js&"
export * from "./SelectPreview.vue?vue&type=script&lang=js&"
import style0 from "./SelectPreview.vue?vue&type=style&index=0&id=5a07b2b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a07b2b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a07b2b3')) {
      api.createRecord('5a07b2b3', component.options)
    } else {
      api.reload('5a07b2b3', component.options)
    }
    module.hot.accept("./SelectPreview.vue?vue&type=template&id=5a07b2b3&scoped=true&", function () {
      api.rerender('5a07b2b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/SelectPreview.vue"
export default component.exports